import { useShallow } from 'zustand/react/shallow';
import { parseYamlTasks } from '@/backend/helpers/parseYamlTasks';
import { Commanding } from '@/backend/models/commanding';
import { CommandingRun } from '@/backend/models/commandingRun';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { ExclamationTriangle } from '@/frontend/SVGs/ExclaimationTriangle';
import { I18n } from '@/i18n/I18n';
import { Operation } from '@/backend/models/operation';
import { CommandingRunBody } from './CommandingRunBody';

export function CommandingItemRun(props: { operation: Operation }) {
  const { operation } = props;
  const commandingItem = operation.commanding as Commanding;
  const commandingRun = useTreeStore(useShallow((state) => state.commandingRuns.find((run: CommandingRun) => run.commandingId === commandingItem.id)));
  const tasksStale = useTasksStale(commandingRun as CommandingRun, commandingItem);

  const inputTasks = commandingItem.inputTasks as string | undefined;
  const noInputTasks = !inputTasks || inputTasks.trim() === '';

  return (
  <div className='d-flex flex-column'>
    { noInputTasks && <div className='d-flex gap-2 align-items-center d-print-none'><ExclamationTriangle color="red" /> <small className='danger-subtle'>{I18n.get('noInputTasks')}</small></ div>}
    { (tasksStale) && <div className='d-flex gap-2 align-items-center d-print-none'><ExclamationTriangle color="red" /> <small className='danger-subtle'>{I18n.get('commandingRunStale')}</small></ div>}
    <CommandingRunBody operation={operation}/>
  </div>
  );
}

function useTasksStale(commandingRun: CommandingRun, commanding: Commanding) {
  if (!commandingRun) return false;
  const commandingRunInputTrimmedYaml = commandingRun?.inputTasks?.trim();
  const commandingItemInputTrimmedYaml = commanding.inputTasks?.trim();

  const commandingRunOutputTrimmedYaml = commandingRun?.outputTasks?.trim();
  const commandingItemOutputTrimmedYaml = commanding.outputTasks?.trim();

  return yamlTasksStale(commandingRunInputTrimmedYaml || '', commandingItemInputTrimmedYaml || '') || yamlTasksStale(commandingRunOutputTrimmedYaml || '', commandingItemOutputTrimmedYaml || '');
};

function yamlTasksStale(commandingRunTaskYaml: string, commandingTaskYaml: string) {
  const commandingRunTasks = parseYamlTasks(commandingRunTaskYaml);
  const commandingTasks = parseYamlTasks(commandingTaskYaml);

  const commandingTaskNames = commandingTasks.map((task) => task.name);
  const commandingRunTaskNames = commandingRunTasks.map((task) => task.name);

  let tasksStale = false;

  if (commandingTaskNames.length !== commandingRunTaskNames.length) {
    tasksStale = true;
  }

  commandingTaskNames.forEach((name, index) => {
    if (name !== commandingRunTaskNames?.[index]) {
      tasksStale = true;
    }
  });

  return tasksStale;
};
